import classNames from "classnames";

export const wrapper = classNames(
    // Mobile
    "mobile:px-12",
    "mobile:py-6",
    "mobile:",
    // Tablet
    "tablet:px-28",
    "tablet:py-10",
    // All
    "relative",
    "bg-[#E4E4E4]"
)

export const heading = classNames(
    // Mobile
    "mobile:text-[20px]",
    "mobile:ml-6",
    // Tablet
    "tablet:text-[40px]",
    "tablet:ml-12",
    // All
)

export const border = classNames(
    // Mobile
    "mobile:w-[45%]",
    // Tablet
    "tablet:w-[25%]",
    // All
    "absolute",
    "-left-4",
    "border-t-2",
    "border-[#04A9F4]",
)

export const pricingContent = classNames(
    // Mobile
    "mobile:py-4",
    "mobile:text-[16px]",
    "mobile:mt-4",
    // Tablet
    "tablet:py-2",
    "tablet:text-[18px]",
    "tablet:mt-6",
    "tablet:text-left",
    // All
    "text-center",
    "font-thin",
)

export const pricingButton = classNames(
    // Mobile
    "mobile:mt-6",
    // Tablet
    "tablet:mt-12",
    // All
    "flex",
    "flex-row",
    "bg-[#343F46]",
    "text-white",
    "py-2",
    "px-6",
    "rounded-xl",
    "mb-4"
)
